import { IIconProps } from '../interface';

const SvgFinland = ({ width = 56, height = 56 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_172_15683)">
      <path
        d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
        fill="#F0F0F0"
      />
      <path
        d="M55.763 24.3479H21.9132H21.9131V0.665558C19.3255 1.23934 16.8723 2.16935 14.6087 3.40453V24.3477V24.3478H0.237016C0.0811563 25.5433 0 26.7622 0 28C0 29.2378 0.0811563 30.4567 0.237016 31.6522H14.6086H14.6087V52.5954C16.8723 53.8305 19.3255 54.7607 21.9131 55.3344V31.6525V31.6523H55.763C55.9186 30.4567 56 29.2378 56 28C56 26.7622 55.9186 25.5433 55.763 24.3479Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_172_15683">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFinland;
